import 'slick-carousel';

const mainMenu = () => {
  jQuery(document).ready(function ($) {
    $('.section2-slider').slick({
      //homepage top
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      swipe: true //speed: 1000,

    });
  });
};

export default mainMenu;